import React, { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import ImageContentCard, {
  IImageContentCard,
} from "@/components/cards/ImageContentCard";

// -------------------------------------------------------------------------------------------

export type ITextWithCardsSectionProps = HTMLAttributes<HTMLElement> & {
  textWithCards?: IImageContentCard[];
  variant?: "primary" | "secondary" | "light_primary" | "white";
};

const bgColor = {
  primary: "bg-primary-100",
  secondary: "bg-secondary-50",
  light_primary: "bg-primary-50",
  white: "bg-white",
};

const TextWithCardsSection: FC<ITextWithCardsSectionProps> = (props) => {
  const { textWithCards, variant = "secondary", className, ...other } = props;

  return (
    <section
      className={clsx(
        "container mx-auto py-10 md:py-14 lg:py-16 xl:py-20",
        className,
      )}
      {...other}
    >
      {/* Equal-gap responsive grid — was using `xl:gap-[75px]` which made
          the cards drift apart on wide viewports. Standardized to the
          gap rhythm the rest of the home/industry grids use. */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {textWithCards?.map((card, idx) => (
          <ImageContentCard
            key={idx}
            image={card.image}
            icon={card.icon}
            heading={card.heading}
            description={card.description}
            button={card.button}
          />
        ))}
      </div>
    </section>
  );
};

export default TextWithCardsSection;
